import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter, Inject, Input, LOCALE_ID, NgZone, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AngularModuleService } from 'src/app/dashboard/angular-module.service';
import { DashboardService } from 'src/app/dashboard/dashboard.service';
import { DashboardAccessService } from 'src/app/dashboard/modals/dashboard-access/dashboard-access.service';
import { SendToSubscriptionService } from 'src/app/dashboard/modals/send-to-subscription/send-to-subscription.service';
import { ModuleContainerComponent } from 'src/app/dashboard/module-container/module-container.component';
import { ModuleContainerService } from 'src/app/dashboard/module-container/module-container.service';
import { ModuleRefreshService } from 'src/app/dashboard/module-container/module-refresh.service';
import { ResponsiveDashboardComponent } from "src/app/dashboard/responsive-dashboard/responsive-dashboard.component";
import { NavigationService } from 'src/app/navigation/navigation.service';
import { DateRangeSelectorService } from 'src/app/reusables/date-range-selector/date-range-selector.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleHelperService } from 'src/app/reusables/services/module-helper.service';
import { TimezoneService } from 'src/app/reusables/services/timezone.service';
import { DashboardModuleResponsive } from 'src/shared/models/module-info.model';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerSetting } from 'src/shared/models/module-manager/module-manager-setting.model';
import { IModuleManagerSettingsComponent, ModuleSettingsAppliedModel } from 'src/shared/models/module-manager/module-manager-settings.models';


@Component({
    selector: 'cv-module-subscription-settings-container',
    templateUrl: './module-subscription-settings-container.component.html',
    styleUrls: ['./module-subscription-settings-container.component.scss']
})
export class ModuleSubscriptionSettingsContainerComponent extends ModuleContainerComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() selectedModule: DashboardModuleResponsive;
    @Input() moduleKey: string = "";
    @Input() triggerApplySettings: EventEmitter<void>;

    // Emit custom settings
    @Output() settingsApplied: EventEmitter<{ [settingName: string]: ModuleManagerSetting<any> }> = new EventEmitter();
    // Emitted when validation fails
    @Output() settingsFailed: EventEmitter<string[]> = new EventEmitter();

    public dashboardManager = { isdashboardProjection: false } as any;

    @ViewChild('dynamicSettings', { read: ViewContainerRef }) settingsViewContainerRef: ViewContainerRef;

    private _dashboardComponent: ResponsiveDashboardComponent

    constructor(@Inject(LOCALE_ID) locale,
        angularModuleService: AngularModuleService,
        componentFactoryResolver: ComponentFactoryResolver,
        cvLocalizationService: CVLocalizationService,
        dateRangeSelectorService: DateRangeSelectorService,
        modalService: NgbModal,
        moduleRefreshService: ModuleRefreshService,
        navigationService: NavigationService,
        changeDetector: ChangeDetectorRef,
        config: CvConfigurationService,
        dashboardAccessService: DashboardAccessService,
        dashboardService: DashboardService,
        element: ElementRef<HTMLElement>,
        moduleContainerService: ModuleContainerService,
        moduleHelperService: ModuleHelperService,
        ngZone: NgZone,
        sendToSubscriptionService: SendToSubscriptionService,
        timeZoneService: TimezoneService,
        private _cvConfigurationService: CvConfigurationService,
    ) {
        super(locale, angularModuleService, componentFactoryResolver, cvLocalizationService, dateRangeSelectorService, modalService, moduleRefreshService,
            navigationService, changeDetector, config, dashboardAccessService, dashboardService, element, moduleContainerService, moduleHelperService,
            ngZone, sendToSubscriptionService, timeZoneService);

        this._dashboardComponent = new ResponsiveDashboardComponent(dashboardService, moduleContainerService, navigationService, timeZoneService,
            cvLocalizationService, _cvConfigurationService, document, ngZone, this.element);
    }

    async ngOnInit(): Promise<void> {
        this.addRemoveSettingsOverrides();

        this.settingsOnly = true;
        this.standaloneMode = true;
        this.moduleInfo = this._dashboardComponent.parseAvailableModulesFromApi([this.selectedModule])[0];
        if (!this.moduleInfo) {
            this.settingsFailed.emit(["Error loading widget", "Could not load widget."]);
            return;
        }
        this.mkey = this.moduleKey;
        this.moduleId = this.moduleInfo?.ModuleID;
        this.moduleManager = new ModuleManager(this);
        this.createModule();
    }

    ngOnDestroy(): void {
        this.addRemoveSettingsOverrides(false);
    }

    async ngAfterViewInit() {
        if (!this.moduleInfo)
            return;
        this.createAngularJsScope();

        this.settingsLoading = true;
        this.changeDetector.detectChanges();
        if (this.genericSettingsLoaded || !this.genericSettingsData)
            await this.moduleManager.loadGenericSettings();
        this.loadChildModule();
    }

    override async applySettings(params?: ModuleSettingsAppliedModel) {
        try {
            if (this.checkHasAllRequired()) {
                // Get custom settings            
                this.settingsApplied.emit(this.moduleManager.customSettings);
                return;
            }
            this.settingsFailed.emit(null);
        }
        catch (err) {
            this.settingsFailed.emit(["Error Saving Settings", "Could not save widget settings"]);
            console.error(err);
        }
    }

    private addRemoveSettingsOverrides(add: boolean = true) {
        const id = "ModuleSubscriptionSettingsOverrides";
        if (add) {
            let style = document.createElement('style');
            let css = `
            html{
                overflow:hidden;
            };
            .DateRangePicker.clickable.picker{
                height: calc(100% - 263px);
                overflow-y: auto;
            }
            .dropDownSearchArea.asSearch,
            .dropDownSearchArea.gsSearch,
            .gsSearchBox.gsSearch{
                position: sticky;
                top: 0;
            }
            `;
            style.id = id;
            style.type = "text/css";
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);
        }
        else {
            let style = document.getElementById(id);
            if (!!style)
                document.head.removeChild(style);
        }
    }

    private createModule() {
        this._dashboardComponent.modules = [];
        this._dashboardComponent.addModule(this.moduleInfo, -1, -1, this.moduleInfo.moduleKey);
        this.module = this._dashboardComponent.modules[0];
    }
}
